import { Grid, Textarea, TextInput } from "@mantine/core";
import { FormikProps } from "formik";
import { FC } from "react";

interface RegionFormFieldsProps {
  formik: FormikProps<any>;
  isCreateMode?: boolean;
}

const spanHalf = { base: 12, md: 6 };

const RegionFormFields: FC<RegionFormFieldsProps> = ({
  formik,
  isCreateMode = false,
}) => {
  const getFieldError = (field: string) =>
    formik.touched[field] && formik.errors[field]
      ? (formik.errors[field] as string)
      : null;

  return (
    <Grid>
      {isCreateMode && (
        <Grid.Col span={spanHalf}>
          <TextInput
            label="Mã địa bàn"
            placeholder="VD: DB"
            withAsterisk
            {...formik.getFieldProps("code")}
            error={getFieldError("code")}
          />
        </Grid.Col>
      )}

      <Grid.Col span={isCreateMode ? spanHalf : 12}>
        <TextInput
          label="Tên địa bàn"
          placeholder="Nhập tên địa bàn"
          withAsterisk
          {...formik.getFieldProps("name")}
          error={getFieldError("name")}
        />
      </Grid.Col>

      {isCreateMode && (
        <Grid.Col span={12}>
          <Textarea
            label="Ghi chú"
            placeholder="Nhập ghi chú (tuỳ chọn)"
            autosize
            minRows={2}
            {...formik.getFieldProps("notes")}
            error={getFieldError("notes")}
          />
        </Grid.Col>
      )}
    </Grid>
  );
};

export default RegionFormFields;
